
define(
	'MHI.BasicEnhancements.ShoppingEntryPoints'
,   [
		'MHI.BasicEnhancements.PLP',
		'MHI.BasicEnhancements.CustomCategoryFields'
	]
,   function (
		PLP,
		CustomCategoryFields
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
		
			PLP.mountToApp(container);
			CustomCategoryFields.mountToApp(container);
		}
	};
});
